import {Directive, Module} from 'app/decorators';

@Module({
    name: "app.directives.selectOnClick",
})
@Directive('select-on-click', function () {
    "ngInject";
    return {
        restrict: 'A',
        link: function (scope, element) {
            element.on('focus', function () {
                this.select();
            });

            scope.$on('$destroy', function () {
                element.off('focus');
            })
        }
    };
})
export default class D {

}



// WEBPACK FOOTER //
// ./src/app/directives/select.on.click.js